import { render, staticRenderFns } from "./FlagshipList.vue?vue&type=template&id=0b8de2e8&scoped=true"
import script from "./FlagshipList.vue?vue&type=script&lang=js"
export * from "./FlagshipList.vue?vue&type=script&lang=js"
import style0 from "./FlagshipList.vue?vue&type=style&index=0&id=0b8de2e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8de2e8",
  null
  
)

export default component.exports